import {
  mdiAspectRatio,
  mdiCheck,
  mdiCircle,
  mdiClose,
  mdiCodeBracesBox,
  mdiCodeTags,
  mdiDelete,
  mdiEraser,
  mdiFileImagePlus,
  mdiFormatAlignCenter,
  mdiFormatAlignJustify,
  mdiFormatAlignLeft,
  mdiFormatAlignRight,
  mdiFormatBold,
  mdiFormatClear,
  mdiFormatColorHighlight,
  mdiFormatFloatLeft,
  mdiFormatFloatNone,
  mdiFormatFloatRight,
  mdiFormatFont,
  mdiFormatHeader1,
  mdiFormatHeader2,
  mdiFormatHeader3,
  mdiFormatHeader4,
  mdiFormatHeader5,
  mdiFormatHeader6,
  mdiFormatHeaderPound,
  mdiFormatIndentDecrease,
  mdiFormatIndentIncrease,
  mdiFormatItalic,
  mdiFormatListBulleted,
  mdiFormatListCheckbox,
  mdiFormatListNumbered,
  mdiFormatParagraph,
  mdiFormatQuoteOpen,
  mdiFormatSize,
  mdiFormatStrikethrough,
  mdiFormatSubscript,
  mdiFormatSuperscript,
  mdiFormatUnderline,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiImagePlus,
  mdiLinkVariantOff,
  mdiLinkVariantPlus,
  mdiMinus,
  mdiOpenInNew,
  mdiPalette,
  mdiRedo,
  mdiSizeL,
  mdiSizeM,
  mdiSizeS,
  mdiTable,
  mdiTableColumnPlusAfter,
  mdiTableColumnPlusBefore,
  mdiTableColumnRemove,
  mdiTableMergeCells,
  mdiTablePlus,
  mdiTableRemove,
  mdiTableRowPlusAfter,
  mdiTableRowPlusBefore,
  mdiTableRowRemove,
  mdiText,
  mdiUndo,
  mdiVideoPlus,
  mdiWater,
} from '@mdi/js'

// Map of icon names to SVG paths
const icons = {
  // toolbar icons
  bold: mdiFormatBold,
  italic: mdiFormatItalic,
  underline: mdiFormatUnderline,
  strike: mdiFormatStrikethrough,
  color: mdiWater,
  highlight: mdiFormatColorHighlight,
  heading: mdiFormatHeaderPound,
  textAlign: mdiFormatAlignCenter,
  fontFamily: mdiFormatFont,
  fontSize: mdiFormatSize,
  fontWeight: mdiFormatBold,
  letterSpacing: mdiText,
  subscript: mdiFormatSubscript,
  superscript: mdiFormatSuperscript,
  bulletList: mdiFormatListBulleted,
  orderedList: mdiFormatListNumbered,
  taskList: mdiFormatListCheckbox,
  indent: mdiFormatIndentIncrease,
  outdent: mdiFormatIndentDecrease,
  link: mdiLinkVariantPlus,
  fileImagePlus: mdiFileImagePlus,
  image: mdiImagePlus,
  video: mdiVideoPlus,
  table: mdiTable,
  blockquote: mdiFormatQuoteOpen,
  horizontalRule: mdiMinus,
  code: mdiCodeTags,
  codeBlock: mdiCodeBracesBox,
  clear: mdiFormatClear,
  undo: mdiUndo,
  redo: mdiRedo,
  markdownTheme: mdiPalette,
  fullscreen: mdiFullscreen,

  // heading
  h1: mdiFormatHeader1,
  h2: mdiFormatHeader2,
  h3: mdiFormatHeader3,
  h4: mdiFormatHeader4,
  h5: mdiFormatHeader5,
  h6: mdiFormatHeader6,
  p: mdiFormatParagraph,

  // textAlign
  left: mdiFormatAlignLeft,
  center: mdiFormatAlignCenter,
  right: mdiFormatAlignRight,
  justify: mdiFormatAlignJustify,

  // misc (not toolbar)
  circle: mdiCircle,
  eraser: mdiEraser,
  close: mdiClose,
  fullscreenExit: mdiFullscreenExit,
  linkVariant: mdiLinkVariantPlus,
  linkVariantOff: mdiLinkVariantOff,
  openInNew: mdiOpenInNew,
  formatFloatLeft: mdiFormatFloatLeft,
  formatFloatNone: mdiFormatFloatNone,
  formatFloatRight: mdiFormatFloatRight,
  sizeS: mdiSizeS,
  sizeM: mdiSizeM,
  sizeL: mdiSizeL,
  aspectRatio: mdiAspectRatio,
  delete: mdiDelete,
  text: mdiText,

  // table
  tablePlus: mdiTablePlus,
  tableRemove: mdiTableRemove,
  tableColumnPlusAfter: mdiTableColumnPlusAfter,
  tableColumnPlusBefore: mdiTableColumnPlusBefore,
  tableColumnRemove: mdiTableColumnRemove,
  tableRowPlusAfter: mdiTableRowPlusAfter,
  tableRowPlusBefore: mdiTableRowPlusBefore,
  tableRowRemove: mdiTableRowRemove,
  tableMergeCells: mdiTableMergeCells,

  check: mdiCheck,
}

// Return an mdi path wrapped for Vuetify's <v-icon> (svg: syntax)
export function getIcon(iconName) {
  if (!iconName) return undefined
  return `svg:${icons[iconName]}`
}

export default icons
